import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(VBreadcrumbs, {
        staticClass: "pa-0 py-2 text--black",
        attrs: { items: _vm.getBreadcrumbs },
      }),
      _c(
        VCard,
        { staticClass: "mt-2", attrs: { flat: "" } },
        [
          _c(
            VForm,
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                VRow,
                { attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "3", lg: "2" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.$t("frases.select_base"))),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "6" } },
                    [
                      _c(VSelect, {
                        attrs: {
                          outlined: "",
                          "hide-details": "auto",
                          dense: "",
                          items: _vm.items,
                          "item-text": "table_id",
                          required: "",
                          "return-object": "",
                          rules: _vm.rules.base,
                        },
                        on: { change: _vm.onSelectView },
                        model: {
                          value: _vm.table,
                          callback: function ($$v) {
                            _vm.table = $$v
                          },
                          expression: "table",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      true
                        ? _c(VCheckbox, {
                            staticStyle: { "margin-top": "0px" },
                            attrs: {
                              label: "Utilizar periodo",
                              "hide-details": "",
                            },
                            on: { change: _vm.onPeriodChange },
                            model: {
                              value: _vm.period,
                              callback: function ($$v) {
                                _vm.period = $$v
                              },
                              expression: "period",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                { attrs: { dense: "" } },
                [
                  _vm.period
                    ? _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s(_vm.$t("frases.select_column")))]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VCol,
                    { attrs: { cols: "6" } },
                    [
                      _vm.period
                        ? _c(VSelect, {
                            attrs: {
                              outlined: "",
                              "hide-details": "auto",
                              dense: "",
                              items: _vm.view_columns,
                              "item-text": "table_id",
                              required: "",
                              "return-object": "",
                              rules: _vm.rules.column,
                            },
                            model: {
                              value: _vm.column,
                              callback: function ($$v) {
                                _vm.column = $$v
                              },
                              expression: "column",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _vm.period
                        ? _c(
                            VAlert,
                            {
                              staticClass: "transparent-bg",
                              attrs: {
                                type: "info",
                                variant: "outlined",
                                text: "text",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("frases.alert_period_column")) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }